var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowShortBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.62818 19.6167C9.8865 19.8647 10.2153 20 10.6027 20C11.3777 20 12 19.4138 12 18.6697C12 18.2976 11.8356 17.9594 11.5656 17.7001L3.34638 9.98873L11.5656 2.29989C11.8356 2.04059 12 1.69109 12 1.33033C12 0.586246 11.3777 0 10.6027 0C10.2153 0 9.8865 0.135287 9.62818 0.383315L0.493151 8.95152C0.164384 9.24465 0.0117417 9.60541 0 10C0 10.3946 0.164384 10.7328 0.493151 11.0372L9.62818 19.6167Z",
    fill: "#251F2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowShortBlack);
export default __webpack_public_path__ + "static/media/arrow_short_black.a447e5159e900ae2512f0ccbb93ee5aa.svg";
export { ForwardRef as ReactComponent };